import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { generatePaletteId, addPalette } from '../redux/paletteDbSlice';
import { generateRelationUserPaletteId, addRelationUserPalette} from '../redux/relationUserPaletteDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useAllPaletteDbs from '../hooks/useAllPaletteDbs';

const AddPaletteDialogContent = styled(DialogContent)`
  width: 30vw;
`
const BookNameTextField = styled(TextField)`
  width: 90%;
`

type AddPaletteDialogProps = {
  open: boolean;
  onClose: () => void;
}
const AddPaletteDialog: React.FC<AddPaletteDialogProps> = ({open, onClose}) => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const [paletteIds] = useAllPaletteDbs(userId);
  const [value, setValue] = useState('new palette');

  const addPaletteExe = () => {
    const paletteId = generatePaletteId();
    const rupId = generateRelationUserPaletteId();
    dispatch(addPalette({id: paletteId, name: value, standard: false}));
    dispatch(addRelationUserPalette({id: rupId, userId: userId || 'no user', paletteId: paletteId, order: paletteIds.length}));
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle></DialogTitle>
      <AddPaletteDialogContent style={{overflow: 'hidden'}}>
        <BookNameTextField label="新しいパレットの名前" variant="outlined" defaultValue={value} 
                            onChange={(ev) => setValue(ev.target.value)}/>
      </AddPaletteDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => addPaletteExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddPaletteDialog;
